(()=>{
    if (!customElements.get('load-more')){
        class LoadMore extends HTMLElement {
            constructor(){
                super();
                this.currentPage = 1;
            }

            connectedCallback() {
                this.setHtmlElements();
                this.bindEvents();

                const urlParams = new URLSearchParams(window.location.search);
                this.hasPageCheck(urlParams);
                this.toggleButtonVisibility();
                
            }
            setHtmlElements() {
                this.productGridWrapper = document.querySelector('.filters-adjacent');
                this.productsOnPage = document.querySelector('.product-list-load');
                this.button = this.querySelector('.load-more_btn');
                this.next_url = this.dataset.nextUrl;
                this.sectionId = this.dataset.sectionId;
            }
            // Ask for the collection section on its own instead of the whole document —
            // same markup, without the header, footer and app scripts around it.
            sectionUrl(url) {
                if (!this.sectionId) return url;

                try {
                    const parsed = new URL(url, window.location.origin);
                    parsed.searchParams.set('section_id', this.sectionId);
                    return parsed.pathname + parsed.search;
                } catch (error) {
                    return url;
                }
            }
            async getNextPage() {
                try {
                    let res = await fetch(this.sectionUrl(this.next_url));
                    return await res.text();
                } catch (error) {
                    console.log(error);
                }
            }
            hasPageCheck(urlParams){
                if (urlParams.has('page')) {
                    urlParams.delete('page');
                    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
                    window.history.replaceState({}, '', newUrl);
                    this.productsOnPage.innerHTML = '';
                    this.button.style.display = 'none';
                    this.productGridWrapper.classList.add('ajax-loading');
                    this.loadInitialProducts(newUrl);
                }
            }

            async loadMoreProducts() {
                this.productGridWrapper.classList.add('ajax-loading');
                this.button.style.display = 'none';
                let nextPage = await this.getNextPage();
                const parser = new DOMParser();
                const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
                const productGrid = nextPageDoc.querySelector('.product-list-load');
                const newButtonUrl = nextPageDoc.querySelector('load-more').dataset.nextUrl;
                const new_products = productGrid.getElementsByClassName('product-block');

                if (new_products.length > 0){
                    this.productsOnPage.append(...new_products);
                    theme.ProductBlockManager.loadImages(this.productsOnPage);
                }
                setTimeout(()=> {
                    this.productGridWrapper.classList.remove('ajax-loading');
                    this.button.style.display = 'block';
                    this.next_url = newButtonUrl;
                    this.setAttribute('data-next-url', newButtonUrl);
                    this.toggleButtonVisibility();
                    if (typeof theme.applyGdaBadgeLabelOffset === 'function') {
                        theme.applyGdaBadgeLabelOffset(this.productsOnPage);
                    }
                    this.currentPage++;
                    const newUrl = new URL(window.location);
                    newUrl.searchParams.set('page', this.currentPage);
                    window.history.pushState({ page: this.currentPage }, '', newUrl);
                }, 500);
            }
            async loadInitialProducts(url) {
                try {
                    let res = await fetch(this.sectionUrl(url));
                    let text = await res.text();
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(text, 'text/html');
                    const productGrid = doc.querySelector('.product-list-load');
                    const products = productGrid.getElementsByClassName('product-block');
                    const newButtonUrl = doc.querySelector('load-more').dataset.nextUrl;
            
                    if (products.length > 0){
                        this.productsOnPage.append(...products);
                        theme.ProductBlockManager.loadImages(this.productsOnPage);
                        if (typeof theme.applyGdaBadgeLabelOffset === 'function') {
                            theme.applyGdaBadgeLabelOffset(this.productsOnPage);
                        }
                    }
                    this.productGridWrapper.classList.remove('ajax-loading');
                    this.button.style.display = 'block';
                    this.next_url = newButtonUrl;
                    this.setAttribute('data-next-url', newButtonUrl);
                } catch (error) {
                    console.log(error);
                }
            }
            toggleButtonVisibility() {
                if (!this.next_url) {
                    this.button.style.display = 'none';
                } else {
                    this.button.style.display = 'block';
                }
            }
            bindEvents(){
                this.button?.addEventListener('click', this.loadMoreProducts.bind(this))
            }
        }
        customElements.define('load-more', LoadMore);
    }
})()